import { render, staticRenderFns } from "./TodayTasks.vue?vue&type=template&id=ca4a8692&scoped=true&"
import script from "./TodayTasks.vue?vue&type=script&lang=js&"
export * from "./TodayTasks.vue?vue&type=script&lang=js&"
import style0 from "./TodayTasks.vue?vue&type=style&index=0&id=ca4a8692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a8692",
  null
  
)

export default component.exports